// Lives in its own file (not inline in alertsFeature.ts) so route factories
// and screens can import these constants without a circular import back
// through alertsFeature.ts -> presentation/routes -> here.
const ALERTS_LIST = "core.alert_management.alert_management_list";

export const ALERTS_VIEW = `${ALERTS_LIST}.view`;
export const ALERTS_CREATE = `${ALERTS_LIST}.create`;
export const ALERTS_UPDATE = `${ALERTS_LIST}.update`;
export const ALERTS_DELETE = `${ALERTS_LIST}.delete`;

/**
 * Alert History (the "log" screen, its details, and Tracking's Alerts tab):
 * what `GET /alerts/history` checks. View only -- history is read, never
 * written. The alert list's own view no longer opens it (the API refuses
 * that, and a refusal sends the app to /unauthorized).
 */
export const ALERT_HISTORY_VIEW = "core.alert_management.alert_history_list.view";

/** A driver-monitoring or road alert's photos and clips
 *  (`GET /alerts/history/:id/evidence`): they show the driver, so they have
 *  their own permission on top of Alert History's. */
export const ALERT_EVIDENCE_VIEW =
  "core.alert_management.driver_monitoring_evidence.view";
